import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Modal, Select, Stack, TextField, Typography } from "@mui/material";
import { CategoryData, CategoryDataError } from "../../types";
import { useEffect, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { ConfirmDialog } from "../../components/global/ConfirmDialog";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";

interface CategoryModalProps {
  open: boolean;
  handleClose:() => void;
  handleSave: () => void,
  category: CategoryData;
  categories: any[];
}

interface CategorySelectOptionProps {
  item: any;
  depth: number;
  mCategory?: any;
}

const CategorySelectOption = ({ item, depth, mCategory }: CategorySelectOptionProps) => {
  const prespace = [];
  for (let i=0; i<depth; i++) prespace.push(i);
  if (item?.children?.length) {
    return (
      <>
        <option value={item?.id} disabled={item?.id == mCategory?.id}>
          {
            prespace.map(() => <>&nbsp;&nbsp;&nbsp;&nbsp;</>)
          }
          {item?.name}
        </option>
        {
          item?.children?.map((child: any) => (
            <>
              <CategorySelectOption item={child} depth={depth + 1} mCategory={mCategory} />
            </>
          ))
        }
      </>
    )
  } else {
    return (
      <>
        <option value={item?.id} disabled={item?.id == mCategory?.id}>
          {
            prespace.map(() => <>&nbsp;&nbsp;&nbsp;&nbsp;</>)
          }
          {item?.name}
        </option>
      </>
    )
  }
}

export const CategoryModal = ({open, handleClose, handleSave, category, categories}: CategoryModalProps) => {
  const [mCategory, setMCategory] = useState<CategoryData>(category);
  const [error, setError] = useState<CategoryDataError>({});
  const { fetchData } = useAPI();
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  useEffect(() => {
    setMCategory({ ...category});
  }, [category]);

  const onSaveCategory = async (category: CategoryData) => {
    const {errors, data} = await fetchData('/categories/save',  category, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  const onDeleteCategory = async (category: CategoryData) => {
    const {errors, data} = await fetchData('/categories/delete',  { id: category.id }, 'POST');
    if (errors) {
      setError(errors);
    } else {
      handleSave();
    }
  }

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
        maxHeight: '90%',
        overflow: 'auto',
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600">
          { category.id ? "Edit Category" : "Add Category" }
        </Typography>
        <Stack mt={4} spacing={4}>
          <FormGroup>
            <Typography fontWeight="600">Category Name</Typography>
            <TextField
              variant="outlined"
              value={mCategory.name}
              error={error.name ? true : false}
              helperText={error?.name?.[0] ?? ''}
              onChange={(e) => setMCategory({ ...mCategory, name: e.target.value })}
              sx={{ width: '100%' }}
            />
          </FormGroup>
          <FormGroup>
            <FormControl>
              <Typography fontWeight="600">Category Parent</Typography>
              <Select 
                native
                variant="outlined"
                value={mCategory.parent_id ?? ''}
                onChange={(e) => setMCategory({ ...mCategory, parent_id: e.target.value })}
                sx={{ width: '100%' }}
              >
                <option></option>
                {
                  categories.map((item: any, index: number) => (
                    <>
                      <CategorySelectOption key={index} item={item} depth={0} mCategory={mCategory} />
                    </>
                  ))
                }
              </Select>
            </FormControl>
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={2}>
              <Button variant="contained" size="large" onClick={() => onSaveCategory(mCategory)}>
                Save Category
              </Button>
              {
                category.id && (
                  <Button variant="outlined" size="large" color="error" onClick={() => 
                    openDialog(
                      "Confirm Deletion",
                      `Are you sure you want to delete the client "${mCategory.name}"?`,
                      () => onDeleteCategory(mCategory)
                    )
                  }>
                    Delete Category
                  </Button>
                )
              }
              <Button variant="text" size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Stack>
          </FormGroup>
        </Stack>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}